import { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import axiosInstance from "../../variables/api/axiosInstance";
import { Button, Modal, Table, Tag } from "antd";
import { toast } from "react-toastify";

const Modules = () => {
  const [modules, setModules] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedModule, setSelectedModule] = useState(null);
  const [nom, setNom] = useState("");
  const [commentaire, setCommentaire] = useState("");
  const [comptable, setComptable] = useState(false);

  useEffect(() => {
    axiosInstance
      .get(`/api/module`)
      .then((res) => {
        setModules(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const columns = [
    {
      title: "Nom", key: "nom", dataIndex: "nom",
      render: (text, record) => record?.comptable ? <Tag color="green">{text}</Tag> : text,
    },
    { title: "Description", key: "description", dataIndex: "commentaire" },
    {
      title: "Actions",
      render: (_, row) => (
        <div class="dropdown">
          <button
            type="button"
            class="btn p-0 dropdown-toggle hide-arrow"
            data-bs-toggle="dropdown"
          >
            <i class="bx bx-dots-vertical-rounded"></i>
          </button>
          <div class="dropdown-menu"
            onClick={() => {
              setEditMode(true);
              setSelectedModule(row);
              setNom(row.nom);
              setCommentaire(row.commentaire);
              setComptable(row.comptable);
              setOpen(true);
            }}>
            <a class="dropdown-item" href="#">
              <i class="bx bx-edit-alt me-1"></i> Modifier
            </a>
          </div>
        </div>
      ),
    },
  ];


  const handleSubmit = () => {
    setLoading(true);
    const data = {
      nom: nom,
      commentaire: commentaire,
      comptable: comptable,
    };

    if (!nom || !commentaire) {
      toast.error("Veuillez remplir tous les champs.");
      setLoading(false);
      return;
    }
    if (editMode) {
      selectedModule.nom = nom;
      selectedModule.commentaire = commentaire;
      selectedModule.comptable = comptable;
      axiosInstance
        .put(`/api/module`, selectedModule)
        .then((res) => {
          setModules(modules.map(mod => mod.moduleId === selectedModule.moduleId ? res.data : mod));
          handleCancel();
          setEditMode(false);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } else {
      axiosInstance
        .post(`/api/module`, data)
        .then((res) => {
          setModules([...modules, res.data]);
          handleCancel();
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  };

  const handleCancel = () => {
    setOpen(false);
    setNom("");
    setCommentaire("");
  };

  return (
    <div class="layout-wrapper layout-content-navbar  ">
      <div class="layout-container">
        <SideBar currentMenu={"DROITS"} />

        {/* <!-- Layout container --> */}
        <div class="layout-page">
          <NavBar />

          {/* <!-- Content wrapper --> */}
          <div class="content-wrapper">
            {/* <!-- Content --> */}
            <div class="container-xxl flex-grow-1 container-p-y">
              <div class="card">
                <h5 class="card-header">
                  Les différents modules de l'application
                </h5>
                <Button onClick={() => setOpen(true)} icon={<i class="bx bx-plus"></i>} style={{ width: "15%", textAlign: "right" }} type="primary">Ajouter un module</Button>
                <div class="table-responsive text-nowrap">
                  <Table
                    columns={columns}
                    dataSource={modules}
                    pagination={true}
                    striped={true}
                    rowKey={(record) => record.moduleId}
                    loading={loading}
                  />
                </div>
              </div>
            </div>
            {/* <!-- / Content --> */}

            {/* <!-- Footer --> */}
            <Footer />
            {/* <!-- / Footer --> */}

            <div class="content-backdrop fade"></div>
          </div>
          {/* <!-- Content wrapper --> */}
        </div>
        {/* <!-- / Layout page --> */}
      </div>

      <Modal
        open={open}
        onOk={handleSubmit}
        onCancel={handleCancel}
        onClose={handleCancel}
        title={editMode ? "Modifier un module" : "Ajouter un module"}
        okText={editMode ? "Modifier" : "Ajouter"}
        cancelText="Annuler"
        centered
      >
        <div class="modal-body">
          {/* Form to add a new module */}
          <form>
            <div class="mb-3">
              <label for="nom" class="form-label">Nom du module</label>
              <input type="text" class="form-control" placeholder="Nom du module" id="nom" value={nom} onChange={(e) => setNom(e.target.value)} />
            </div>
            <div class="mb-3">
              <label for="commentaire" class="form-label">Description</label>
              <textarea
                class="form-control"
                id="commentaire"
                rows="3"
                placeholder="Description du module"
                value={commentaire}
                onChange={(e) => setCommentaire(e.target.value)}
              ></textarea>
            </div>
            <div class="mb-3 form-check">
              <input
                type="checkbox"
                class="form-check-input"
                id="comptable"
                checked={comptable}
                onChange={(e) => setComptable(e.target.checked)}
              />
              <label class="form-check-label" for="comptable">Module Comptable ?</label>
            </div>
          </form>
        </div>
      </Modal>

      {/* <!-- Overlay --> */}
      <div class="layout-overlay layout-menu-toggle"></div>

      {/* <!-- Drag Target Area To SlideIn Menu On Small Screens --> */}
      <div class="drag-target"></div>
    </div>
  );
};

export default Modules;
